import qwest from 'qwest';

window.qwest = qwest;

window.$ = window.$ || false;
